import { connect } from 'react-redux';
import { collectFave } from '../../CollectionPanel/redux/actionCreators';
import { getIsFavourite } from '../../CollectionPanel/redux/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { getCurrentUser } from '../../publicSession/selectors';
const mapStateToProps = (state, ownProps)=>({
        currentUser: getCurrentUser(state),
        isFavourite: getIsFavourite(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    onAddToCollection: collectFave,
    addNotification: addNotificationToQueue
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector;

//# sourceMappingURL=FaveNotification.container.js.map